// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.job-metadata-details {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 20px;
  width: 100%;
}

.details-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.details-header h3 {
  margin: 0;
  font-size: 1.2rem;
  color: #333;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #888;
  padding: 0 5px;
}

.close-button:hover {
  color: #333;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.loader {
  border: 3px solid #f3f3f3;
  border-radius: 50%;
  border-top: 3px solid #3498db;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-container {
  padding: 15px;
  background-color: #fff0f0;
  border-left: 3px solid #ff5555;
  margin-bottom: 15px;
}

.error-message {
  color: #d32f2f;
  margin: 0;
}

.metadata-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.metadata-section {
  margin-bottom: 15px;
}

.metadata-section h4 {
  font-size: 1rem;
  margin: 0 0 8px 0;
  color: #555;
}

.processing-info-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.processing-info-list li {
  padding: 5px 0;
  border-bottom: 1px solid #f0f0f0;
  font-size: 0.9rem;
}

.processing-info-list li:last-child {
  border-bottom: none;
}

.chunk-selector {
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background-color: #fff;
  width: 100%;
  max-width: 200px;
  font-size: 0.9rem;
}

.clips-preview {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.clip-preview-item {
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 6px;
  border-left: 3px solid #3498db;
}

.clip-title {
  font-weight: bold;
  margin-bottom: 5px;
}

.clip-score {
  font-size: 0.85rem;
  color: #666;
}

.more-clips {
  text-align: center;
  padding: 8px;
  background-color: #f0f0f0;
  border-radius: 4px;
  font-size: 0.9rem;
  color: #555;
  margin-top: 5px;
}

.view-details-container {
  text-align: center;
  margin-top: 10px;
}

.view-details-button {
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 15px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.view-details-button:hover {
  background-color: #2980b9;
}

.no-metadata {
  padding: 20px;
  text-align: center;
  color: #777;
  font-style: italic;
} `, "",{"version":3,"sources":["webpack://./src/components/css/JobMetadataDetails.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".job-metadata-details {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.details-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 10px;\n}\n\n.details-header h3 {\n  margin: 0;\n  font-size: 1.2rem;\n  color: #333;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #888;\n  padding: 0 5px;\n}\n\n.close-button:hover {\n  color: #333;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.loader {\n  border: 3px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 3px solid #3498db;\n  width: 30px;\n  height: 30px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 10px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.error-container {\n  padding: 15px;\n  background-color: #fff0f0;\n  border-left: 3px solid #ff5555;\n  margin-bottom: 15px;\n}\n\n.error-message {\n  color: #d32f2f;\n  margin: 0;\n}\n\n.metadata-content {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.metadata-section {\n  margin-bottom: 15px;\n}\n\n.metadata-section h4 {\n  font-size: 1rem;\n  margin: 0 0 8px 0;\n  color: #555;\n}\n\n.processing-info-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.processing-info-list li {\n  padding: 5px 0;\n  border-bottom: 1px solid #f0f0f0;\n  font-size: 0.9rem;\n}\n\n.processing-info-list li:last-child {\n  border-bottom: none;\n}\n\n.chunk-selector {\n  padding: 8px 12px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  background-color: #fff;\n  width: 100%;\n  max-width: 200px;\n  font-size: 0.9rem;\n}\n\n.clips-preview {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.clip-preview-item {\n  padding: 10px;\n  background-color: #f9f9f9;\n  border-radius: 6px;\n  border-left: 3px solid #3498db;\n}\n\n.clip-title {\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n.clip-score {\n  font-size: 0.85rem;\n  color: #666;\n}\n\n.more-clips {\n  text-align: center;\n  padding: 8px;\n  background-color: #f0f0f0;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  color: #555;\n  margin-top: 5px;\n}\n\n.view-details-container {\n  text-align: center;\n  margin-top: 10px;\n}\n\n.view-details-button {\n  background-color: #3498db;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 10px 15px;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.view-details-button:hover {\n  background-color: #2980b9;\n}\n\n.no-metadata {\n  padding: 20px;\n  text-align: center;\n  color: #777;\n  font-style: italic;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
